import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import './StickyMobileBar.css';

const StickyMobileBar = () => {
  return (
    <nav className="sticky-mobile-bar" aria-label="Hızlı iletişim">
      <a href={SITE.phoneHref} className="smb-btn smb-call">
        <FaPhoneAlt />
        <span>Hemen Ara</span>
      </a>
      <a
        href={SITE.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="smb-btn smb-whatsapp"
      >
        <FaWhatsapp />
        <span>WhatsApp</span>
      </a>
    </nav>
  );
};

export default StickyMobileBar;
